import {
  Box,
  Typography,
  Stack,
  Button,
  Divider,
  Container
} from '@mui/material';

import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

//components
import { CardContent, Card } from 'src/@/components/ui/card';
import Label from 'src/components/Label';
import Iconify from 'src/components/Iconify';
import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';

//functions
import { formataNumeroCelular, verifyRules } from 'src/utils/functions';

//actions
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import getActionClienteByClienteId from 'src/actions/clientes/getActionClienteByClienteId';
import v2_actionDeletarCanal from 'src/actions/v2/cliente/canais/v2_actionDeletarCanal';
import v2_actionEditarCanal from 'src/actions/v2/cliente/canais/v2_actionEditarCanal';
import v2_actionCalendarios from 'src/actions/v2/calendario/v2_actionCalendarios';
import { ModalNovoCalendario } from './components/ModalNovoCalendario';


export default function CalendariosConfig({ 
  user, 
  listaCanais, 
  onConnect, 
  onCallback 
}) {
  const navigate = useNavigate()
  const [list, setList] = useState([])


  async function getList() {
    try {
      const response = await v2_actionCalendarios(user.clienteId)
      if(response.status === 200) {
        setList(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }



  useEffect(() => {
    getList()
    onCallback()
  }, [])


  return (
    <Container maxWidth="lg">

      <HeaderPageComponentConfig
        titulo="Calendarios"
        descricao={'Gerencie multiplos calendarios'}
      //  actions={<Button variant='contained'>Teste</Button>}
      />

        <Box
          sx={{
            display: 'grid',
            gap: 1,
            flexDirection: 'row',
            mt:2,
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(4, 1fr)',
              lg: 'repeat(4, 1fr)',
            },
          }}
        >


          {list && list.map((item, index) => (

            <CalendarioCard
              user={user}
              onDelete={() => {}}
              onConfig={() => {
                navigate({
                  pathname: '/dashboard/configuracoes/calendario',
                  search: '?id=' + item._id
                })
              }}
              canal={item}
            />

          )
          )}
          <ModalNovoCalendario
           user={user}
           onCallback={id => {
            navigate({
              pathname: '/dashboard/configuracoes/calendario',
              search: '?id=' + id
            })
           }}
          />

        </Box>
    </Container>
  );
}


function CalendarioCard({ user, canal, botao, onConfig, fbLogin, onDelete }) {

  function formatIcons(key) {
    switch (key) {
      case "whatsapp":
        return <Iconify icon={"dashicons:whatsapp"} width={16} height={16} />
      case "instagram":
        return <Iconify icon={"ri:instagram-fill"} width={16} height={16} />
      case "messenger":
        return <Iconify icon={"mingcute:messenger-fill"} width={16} height={16} />
      default:
        break;
    }

  }

  return (
    <Card className="">
      <CardContent>
      <Stack className='mt-5' spacing={2}>
        <Stack direction="column" alignItems="center" justifyContent="center" spacing={2} >
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
           <div className='flex flex-col gap-2 text-center'>
           <h5 className='text-md'>
              {canal.name}
            </h5>
            <p className='text-xs font-bold'>
              {canal.source}
            </p>
           </div>
       
          </Stack>


        </Stack>
        <Divider sx={{ borderStyle: 'dashed' }}></Divider>

        <Stack sx={{ mt: 1, mb: 2 }}>
          <Stack direction={"column"} alignItems={"center"} spacing={1.5}>
    
       

            {verifyRules(user.rules, "editar_canal") && (
              <Stack direction="row" spacing={1} >

                <Button
                  variant="default"
                  size="small"
                  sx={{ height: 20, borderRadius: 0.5, fontSize: 12, fontWeight: 600, textTransform: 'none' }}
                  onClick={onConfig}
                  startIcon={<Iconify icon="icon-park-outline:config" width={15} height={15} />}
                >
                  Configurar
                </Button>
                {user.clienteId !== canal.cliente_id && (
                  <Button
                    variant="default"
                    size="small"
                    sx={{ height: 20, borderRadius: 0.5, fontSize: 12, fontWeight: 600, textTransform: 'none' }}
                    onClick={onDelete}
                    startIcon={<Iconify color="red" icon="mi:delete" width={15} height={15} />}
                  >
                    Excluir
                  </Button>
                )}

              </Stack>
            )}

          </Stack>

        </Stack>
      </Stack>

      </CardContent>
    </Card>

  );
}
// ----------------------------------------------------------------------


